const workerTypeReducer = (data = [], action) => {	
  if (action.type === 'FETCH_WORKER_TYPES_LIST') {
    return action.payload;
  }
  return data;
};

export default workerTypeReducer